import clsx from "clsx";
import classes from "./Button.module.css";
const Button = ({
  variant = "primary",
  label,
  className,
  disabled,
  leftIcon,
  isSelected,
  children,
  onClick = () => {},
  type = "button",
  list = [],
  onButtonClick = () => {},
  dropdown,
}) => {
  let content = children || label;
  if (leftIcon) {
    content = [leftIcon, label && <> {label}</>];
  }

  return (
    <button
      disabled={disabled}
      className={clsx(
        classes.button,
        {
          [classes.primary]: variant === "primary",
          [classes.white]: variant === "white",
          [classes.secondary]: variant === "secondary",
          [classes.withIcon]: variant === "role",
          [classes.selected]: variant === "role" && isSelected,
          [classes.paginationBtn]: variant === "pageBtn",
          [classes.viewBtn]: variant === "view",
          [classes.cancel]: variant === "cancel",
          [classes.confirm]: variant === "confirm",
          [classes.iconBtn]: variant === "iconBtn",
          [classes.tabBtn]: variant === "tabBtn",
          [classes.accent]: variant === "accent",
          [classes.transparent]: variant === "transparent",
          [classes.add]: variant === "add",
          [classes.danger]: variant === "danger",
          [classes.leftIcon]: leftIcon,
        },
        className
      )}
      onClick={(e) => {
        onClick();
      }}
      type={type}
    >
      {content}
    </button>
  );
};

export default Button;
